
import { IPerson } from './person';

export interface IAuthorized {
  id: number;
  person: IPerson;
  type: string;
}

export const emptyAuthorized: IAuthorized = {
  id: -1,
  person: null,
  type: '',
};




// WEBPACK FOOTER //
// ./src/app/model/authorized.ts